var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFaqIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FC3C3C",
  clipPath: "url(#faq-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 .81H3A2.453 2.453 0 0 0 .55 3.26v7.615A2.453 2.453 0 0 0 3 13.325h1.05v1.233c0 .173.072.34.199.46a.63.63 0 0 0 .464.17 3.63 3.63 0 0 0 2.963-1.863H13a2.453 2.453 0 0 0 2.45-2.45V3.261A2.453 2.453 0 0 0 13 .81m1.55 10.065c0 .854-.696 1.55-1.55 1.55H7.4a.45.45 0 0 0-.41.263 2.73 2.73 0 0 1-2.04 1.57v-1.383a.45.45 0 0 0-.45-.45H3c-.855 0-1.55-.696-1.55-1.55V3.261c0-.855.695-1.55 1.55-1.55h10c.854 0 1.55.695 1.55 1.55z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.426 4.013A1.92 1.92 0 0 0 6.08 5.887a.45.45 0 0 0 .9 0q0-.245.109-.459a1.02 1.02 0 0 1 1.146-.535 1 1 0 0 1 .757.75 1.02 1.02 0 0 1-.53 1.153 1.63 1.63 0 0 0-.912 1.45.45.45 0 0 0 .9 0c0-.267.162-.516.421-.648a1.93 1.93 0 0 0 1-2.154 1.9 1.9 0 0 0-1.445-1.431M8.17 9.305a.46.46 0 0 0-.49.095c-.08.085-.13.2-.13.32a.453.453 0 0 0 .45.45c.06 0 .115-.015.17-.035a.5.5 0 0 0 .15-.1c.08-.08.13-.2.13-.315 0-.12-.05-.235-.13-.32a.5.5 0 0 0-.15-.095"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "faq-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgFaqIcon;